import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatistikService } from '../../statistik.service';
import { filter, map, switchMap } from 'rxjs/operators';
import { combineLatest, Observable, Subject } from 'rxjs';
import { StatistikProduktivitetAfdelinger } from './StatistikProduktivitetAfdelinger';

@Component({
    selector: 'app-statistik-produktivitet',
    template: `<app-statistik-produktivitet-ui
        [afdelinger]="afdelinger$ | async"
        [periode]="periode$ | async"
        (periodeChange)="periodeChange($event)"
    ></app-statistik-produktivitet-ui>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikProduktivitetContainerComponent {
    periodeSubject = new Subject<{fra: string, til: string}>();
    periode$ = this.periodeSubject.asObservable();

    afdelinger$: Observable<StatistikProduktivitetAfdelinger[]> = combineLatest([
        this.statistikService.visible$,
        this.statistikService.step$,
        this.periode$
    ]).pipe(
        filter(([visible, step]) => visible && step === 1),
        switchMap(([, , periode]) => this.statistikService.getStatistikProduktivitet(periode).pipe(
            map(data => {
                const afdelingNavne = data.map(row => row.afdeling)
                    .filter((value, index, self) => self.indexOf(value) === index);
                return afdelingNavne.map(afdelingNavn => {
                    return {
                        afdelingNavn: afdelingNavn,
                        medarbejdere: data.filter(row => row.afdeling === afdelingNavn)
                    };
                });
            })
        )
    ));

    constructor(
        private statistikService: StatistikService
    ) { }

    periodeChange(periode: {fra: string; til: string}) {
        this.periodeSubject.next(periode);
    }
}
